import { tokens, hairline } from "../tokens";
import type { AccentName } from "../tokens";

interface StatusPillProps {
	// Micro cap state text (health, readiness). Uppercased at render.
	label: string;
	// The accent naming the state. green up, gold degraded, red down, blue in progress.
	accent: AccentName;
	// Breathe the dot when the state is live and still changing. Off for a settled state.
	pulse?: boolean;
}

// A state readout: a coloured dot plus its name. The dot carries the accent; the pill is an outline
// over the accent wash, not a filled block. One state, one colour.
export function StatusPill({ label, accent, pulse = false }: StatusPillProps) {
	const color = tokens.color.accent[accent];
	return (
		<span
			style={{
				display: "inline-flex",
				alignItems: "center",
				gap: tokens.space.sm,
				padding: `${tokens.space.xs}px ${tokens.space.md}px`,
				background: tokens.color.accentWash[accent],
				border: hairline(color),
				borderRadius: tokens.radius.pill,
				color,
				...tokens.type.microcap,
			}}
		>
			<span
				aria-hidden="true"
				style={{
					width: tokens.glyph.dot,
					height: tokens.glyph.dot,
					borderRadius: tokens.radius.pill,
					background: color,
					animation: pulse ? `mm-breath ${tokens.motion.breath}ms ${tokens.motion.easing} infinite` : undefined,
				}}
			/>
			{label}
		</span>
	);
}
